import { apiClient } from "./client";

export type Clocking = {
  id: string;
  assignment_id: string;
  practitioner_id: string;
  clock_in_at: string;
  clock_out_at: string | null;
  notes: string | null;
  actual_minutes: number | null;
  planned_minutes: number | null;
  delta_minutes: number | null;
  is_open: boolean;
};

export async function clockIn(assignmentId: string, notes?: string): Promise<Clocking> {
  const { data } = await apiClient.post<Clocking>(
    `/api/v1/me/assignments/${assignmentId}/clock-in`,
    { notes: notes || null },
  );
  return data;
}

export async function clockOut(assignmentId: string, notes?: string): Promise<Clocking> {
  const { data } = await apiClient.post<Clocking>(
    `/api/v1/me/assignments/${assignmentId}/clock-out`,
    { notes: notes || null },
  );
  return data;
}

export async function getCurrentClocking(): Promise<Clocking | null> {
  const { data } = await apiClient.get<Clocking | null>("/api/v1/me/clockings/current");
  return data;
}

export async function listClockings(
  params: { from?: string; to?: string; limit?: number } = {},
): Promise<Clocking[]> {
  const { data } = await apiClient.get<Clocking[]>("/api/v1/me/clockings", { params });
  return data;
}
